import { TUDO_NO_APP } from '../conteudo';

// Tudo num app só — grade de 2 colunas com cartõezinhos.
export default function TudoNumApp() {
  return (
    <section className="app-entra mt-10" style={{ animationDelay: '120ms' }}>
      <h2 className="text-[19px] font-extrabold text-foreground-950 md:text-[24px]">
        {TUDO_NO_APP.titulo}
      </h2>
      <div className="mt-4 grid grid-cols-2 gap-3">
        {TUDO_NO_APP.itens.map((item) => (
          <div
            key={item.titulo}
            className="rounded-[18px] border border-background-200 bg-background-50 p-4 shadow-pcard"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-[12px] bg-primary-50 text-primary-600">
              <i className={`${item.icone} text-[20px]`} aria-hidden />
            </span>
            <h3 className="mt-2.5 text-[14px] font-extrabold leading-snug text-foreground-950">
              {item.titulo}
            </h3>
            <p className="mt-1 text-[13px] leading-snug text-foreground-600">{item.texto}</p>
          </div>
        ))}
      </div>
    </section>
  );
}